// 逸游高品需求
const Customize = () => import('@/views/eu/Customize')

export default [
  {
    path: '/eu',
    redirect: '/eu/customize'
  },
  {
    path: '/eu/customize',
    component: Customize,
    meta: {
      title: '为您定制'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/eu.js